import { DialogProductImagesComponent } from "./../dialog-product-images/dialog-product-images.component";
import { Location } from "@angular/common";
import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService, NbToastrService } from "@nebular/theme";
import { MeasurementUnit } from "app/models/measurement-unit/measurement-unit";
import { SimpleProduct } from "app/models/product/product/simple-product";
import { SiteSettings } from "app/pages/settings/settings-page/site-settings";
import { ProductService } from "app/services/product/product.service";
import { CartService } from "../../../services/cart/cart.service";
import { Product } from "../product";

@Component({
  selector: "ultra-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  productParam: SimpleProduct;

  loadingQuantity = false;
  product: Product;
  measurementUnit: number;
  measurementQuantity: number = 1;
  idMeasure: any;
  hasError: boolean = false;
  styleConfig = { backgroundColor: "#00569a", color: "#ffffff" };

  selectedMeasurementUnit: MeasurementUnit;
  siteSettings = SiteSettings.getInstance();

  constructor(
    private local: Location,
    private router: Router,
    private _cartService: CartService,
    private _productService: ProductService,
    private _route: ActivatedRoute,
    public zone: NgZone,
    private _toastrService: NbToastrService,
    private dialogService: NbDialogService
  ) { }

  ngOnInit() {
    this._route.queryParams.subscribe((value) => {
      if (this.productParam == null) {
        const temp: SimpleProduct = JSON.parse(
          sessionStorage.getItem("transitionalProduct")
        );

        if (
          temp != null &&
          temp.id == value["productId"] &&
          temp.classificationId == value["clasId"]
        ) {
          this.productParam = temp;
        } else {
          this._productService
            .getSimpleByIdAndClas(value["productId"], value["clasId"])
            .subscribe((result: any) => {
              this.productParam = SimpleProduct.fromJsonSimpleProduct(result.data);
            })
            .add(() => (this.hasError = this.productParam == null));
        }
      }

      this._productService
        .getProductByIdAndClas(value["productId"], value["clasId"])
        .subscribe(
          (productResponse: any) => {
            this.product = Product.fromJson(productResponse.data);
            if (
              this.productParam &&
              this.productParam != null &&
              this.productParam.selectedMeasurementUnit == null &&
              this.product.measurementUnits.length > 0
            ) {
              this.selectedMeasurementUnit = this.product.measurementUnits.find(
                (e) => e.defaultUnit
              );
            } else if (
              this.productParam &&
              this.productParam.selectedMeasurementUnit != null &&
              this.product.measurementUnits.length > 0
            ) {
              this.selectedMeasurementUnit = this.product.measurementUnits.find(
                (e) =>
                  e.measurementInitials ===
                  this.productParam.selectedMeasurementUnit
              );
            } else if (this.product.measurementUnits.length == 1) {
              this.selectedMeasurementUnit = this.product.measurementUnits[0];
            }
          },
          (error) => {
            this._toastrService.danger(
              "Falha ao buscar dados do produto",
              "Erro"
            );
            this.hasError = true;
          }
        );
    });
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem("transitionalProduct");
  }

  compareMeasurement(measurement: MeasurementUnit): boolean {
    if (this.selectedMeasurementUnit == null) return false;

    return (
      this.productParam.selectedQuantity > 0 &&
      this.selectedMeasurementUnit.id !== measurement.id
    );
  }

  changeLoading(event: boolean) {
    this.loadingQuantity = event;
  }

  selectMeasurement(measurement: MeasurementUnit, event: any) {
    event.currentTarget.blur();
    if (!this.loadingQuantity)
      this.zone.run(() => {
        this.selectedMeasurementUnit = measurement;
        //this.productParam.price = +((this.product.price * this.selectedMeasurementUnit.indexPrice).toFixed(4));
      });
  }

  updateSessionDetail(product) {
    sessionStorage.setItem("productDetails", JSON.stringify(product));
  }

  getProductName(): string {
    return this.product.clasName != ""
      ? this.product.name + " - " + this.product.clasName
      : this.product.name;
  }

  getTotal(product: Product, measurementUnit: MeasurementUnit) {
    if (!this.productParam.hasOwnProperty("selectedQuantity")) return 0;

    let price = product.offerPrice != 0 ? product.offerPrice : product.price;
    let unitQuantity = this.selectedMeasurementUnit.quantity ?? 1;
    let index = this.selectedMeasurementUnit.indexPrice ?? 1;
    return ((price * unitQuantity) * index) * measurementUnit.cartQuantity;
  }

  productDetail(): string {
    return this.product.classApplication == ""
      ? this.product.productApplication
      : this.product.classApplication;
  }

  imgDetail() {
    this.dialogService.open(DialogProductImagesComponent, {
      context: {
        productImages: this.product.links,
      },
    });
  }

  haveDetailToShow() {
    const description = this.productDetail();

    return (
      this.haveInfoProductDetail() ||
      (description != "" && description != null && description != undefined)
    );
  }

  haveInfoProductDetail() {
    return (
      this.siteSettings?.getInfoProductDetail() &&
      this.product.properties.length > 0
    );
  }

  navigateBack() {
    this.local.back();
  }
}
